// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OZ6-","label":"styles_label__2-uj_"};